const rolePermissions = "auth-api/role-permissions/";
const operatorProfile = "operator/operator";
const userProfile = "auth-api/user-info-profile/";
const BOOKINGS_API = "asc-booking/bookings/"; 
const SingleBookingProcess_API = "asc-booking/process-booking/";
const vendorEndpoint = "vendor/policy_providers/";
const USERCREATE_API = "auth-api/user-create/";
const AssignCover_API = "issuance/assign-plan/";
const CustomizeCovers_API = "issuance/covers-and-customize-covers/";
const RemoveAssignCover_API = "issuance/user-cover-plan-access/remove/";
const TripsEndpoint_API = "issuance/policies/user-specific/trips/";
const TravellersEndpoint_API = "issuance/policies/user-specific/travellers/";
const OperatorProfile_API = "operator/operator-profiles/";
const WalletEndpoint_API = "asc-wallet/user-wallet";
const DashboardNotification_Api = "notification/notifications-dashboard/";
const MotherCover_Api = "cover-api/mother-covers/";
const MasterCover_Api = "cover-api/master-covers/";
const CustomizeCover_Api ="cover-api/customize-covers/";
const PlanApproval_Api =  "cover-api/approval-requests/";
const SalesLeads_Api = "crm/leads/";
const SalesCrmStats_Api = "crm/stats/";
const SalesReport_Api = "crm/sales-report/";
const SalesAgentReport_Api = "crm/sales-report/agents/";
const SalesFollowups_Api = "crm/followups/";
const SalesQueries_Api = "crm/queries/";

export  {
    rolePermissions,
    operatorProfile,
    userProfile,
    BOOKINGS_API,
    SingleBookingProcess_API,
    vendorEndpoint,
    USERCREATE_API,
    AssignCover_API,
    CustomizeCovers_API,
    RemoveAssignCover_API,
    TripsEndpoint_API,
    TravellersEndpoint_API,
    OperatorProfile_API,
    WalletEndpoint_API,
    DashboardNotification_Api,
    MotherCover_Api,
    MasterCover_Api,
    CustomizeCover_Api,
    PlanApproval_Api,
    SalesLeads_Api,
    SalesCrmStats_Api,
    SalesReport_Api,
    SalesAgentReport_Api,
    SalesFollowups_Api,
    SalesQueries_Api,
}